import {ServiceUsage} from "@/lib/types/checks.ts";
import {DateFormatName, TimeFormatName} from "@/lib/types/common.ts";

import {InstantCheckoutContainer} from "./InstantCheckoutContainer.tsx";
import {InstantCheckoutPurchaseSuccess} from "./InstantCheckoutPurchaseSuccess.tsx";
import {InstantCheckoutRequestSuccess} from "./InstantCheckoutRequestSuccess.tsx";

interface InstantCheckoutSuccessProps {
  userCanPurchase: boolean;
  serviceUsage: ServiceUsage;
  timeFormat: TimeFormatName;
  dateFormat: DateFormatName;
  timezone: string;
}

export const InstantCheckoutSuccess = ({
  userCanPurchase,
  serviceUsage,
  timezone,
  timeFormat,
  dateFormat,
}: InstantCheckoutSuccessProps) => (
  <InstantCheckoutContainer
    alertVariant={"verification"}
    message={
      userCanPurchase ? (
        <InstantCheckoutPurchaseSuccess serviceUsage={serviceUsage} />
      ) : (
        <InstantCheckoutRequestSuccess
          serviceUsage={serviceUsage}
          timeFormat={timeFormat}
          dateFormat={dateFormat}
          timezone={timezone}
        />
      )
    }
  />
);
